import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import EventEmitter from 'eventemitter3';
import uuid from '../utils/uuid';
import { withStyles } from '../theme';
import { isolateMixin } from '../utils/mixins';
import { RadioButtonContext } from './context';

var styles = function styles(theme) {
  return {
    radioButtonGroup: {
      extend: isolateMixin,
      fontFamily: theme.fontFamily
    }
  };
};

var RadioButtonGroup = /*#__PURE__*/function (_PureComponent) {
  _inherits(RadioButtonGroup, _PureComponent);

  var _super = _createSuper(RadioButtonGroup);

  function RadioButtonGroup() {
    var _this;

    _classCallCheck(this, RadioButtonGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.value = _this.props.value;

    _this.getRadioInputName = function () {
      _this.resultRadioInputName = _this.resultRadioInputName || _this.props.name || "RadioGroup-".concat(uuid());
      return _this.resultRadioInputName;
    };

    _this.onNewValue = function (event, value) {
      if (_this.props.onChange) _this.props.onChange(event, value);
    };

    return _this;
  }

  _createClass(RadioButtonGroup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.value !== prevProps.value) {
        this.value = this.props.value;
        if (this.radioInputEvents) this.radioInputEvents.emit('updateValue', this.value);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.radioInputEvents) this.radioInputEvents.removeAllListeners();
    }
  }, {
    key: "createRadioInputEvents",
    value: function createRadioInputEvents() {
      this.radioInputEvents = new EventEmitter();
      this.radioInputEvents.on('newValue', this.onNewValue);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          classes = _this$props.classes,
          children = _this$props.children,
          theme = _this$props.theme,
          onChange = _this$props.onChange,
          value = _this$props.value,
          labelPosition = _this$props.labelPosition,
          otherRootProps = _objectWithoutProperties(_this$props, ["className", "classes", "children", "theme", "onChange", "value", "labelPosition"]);

      var resultClassName = classnames(classes.radioButtonGroup, className);
      return React.createElement(RadioButtonContext.Provider, {
        value: this.contextValue
      }, React.createElement("div", _extends({
        className: resultClassName
      }, otherRootProps), children));
    }
  }, {
    key: "contextValue",
    get: function get() {
      var _this2 = this;

      if (!this.radioInputEvents) this.createRadioInputEvents();
      return {
        events: this.radioInputEvents,
        getName: this.getRadioInputName,
        getValue: function getValue() {
          return _this2.value;
        }
      };
    }
  }]);

  return RadioButtonGroup;
}(PureComponent);

RadioButtonGroup.defaultProps = {
  name: null,
  onChange: function onChange() {}
};
RadioButtonGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Имя, которое будет применяться ко всей группе radio.
   * Генерируется автоматически, если не указано
   */
  name: PropTypes.string,

  /**
   * Дочерние узлы - radio
   */
  children: PropTypes.node,

  /**
   * Css - класс компонента
   */
  className: PropTypes.string,

  /**
   * Добавление стандартных стилей для группы
   */
  style: PropTypes.object,

  /**
   * Обязательный колбэк, который вызывается при нажатии на input и меняет state root-компонента.
   */
  onChange: PropTypes.func.isRequired,

  /**
   * Значение, выбранного в данный момент radio
   */
  value: PropTypes.any,

  /**
   * Позиция label - либо слева, либо справа
   */
  labelPosition: PropTypes.oneOf(['left', 'right'])
} : {};
export default withStyles(styles, {
  name: 'RadioButtonGroup'
})(RadioButtonGroup);